<div class="col-xs-5 no-padding">
    <span [class]="getPaymentClass()">
        ({{Math.abs(paymentDifference) | localeCurrency}} {{ getPaymentDifferenceLabel() | translate}})
    </span>
</div>